/* KANON `Raporty` — the roster on a survey card, transcribed from `01-ankiety.html`'s `.ava`:
 *   disc     34px, a circle, 2px ring in the card's own ground
 *   overlap  6px, front to back, so the first face is on top
 *   +N       the same disc with tabular figures, LAST in the stack
 *
 * Since 5 November 2026 the disc itself is `shared/ui/AvatarChip` (owner: one shared asset, the
 * roster's lighter initials). This sheet owns only the ring and the overlap, on a `.slot` wrapper,
 * and hands the chip its diameter through `--sz-avatar`: the slot's outer size minus the ring.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js). */

.stack {
  --sz-stack-face: var(--sz-report-face);

  display: inline-flex;
  flex: none;
  align-items: center;
}

/* The ring in the card's own ground, drawn as the wrapper's padding so the chip inside stays the
 * shared control untouched. The slot's outer size is the canon's disc. */
.slot {
  --sz-avatar: calc(var(--sz-stack-face) - 2 * var(--border-focus));

  display: grid;
  flex: none;
  place-items: center;
  padding: var(--border-focus);
  background: var(--bg-card);
  border-radius: var(--r-circle);
}

.slot + .slot {
  margin-inline-start: -6px;
}

.more {
  font-variant-numeric: tabular-nums;
}

.editor {
  --sz-stack-face: var(--sz-report-face-editor);
}

.editor .slot + .slot {
  margin-inline-start: -9px;
}
